import { Link, useLocation } from "react-router-dom";
import { formatLibraryName } from "@/lib/utils";

interface GuestCatalogFooterProps {
  libraryName: string;
}

export function GuestCatalogFooter({ libraryName }: GuestCatalogFooterProps) {
  const location = useLocation();
  const displayName = formatLibraryName(libraryName);
  const returnUrl = encodeURIComponent(location.pathname + location.search);

  return (
    <footer className="mt-auto border-t border-gray-200 bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-4 py-8 text-center text-sm text-gray-600 sm:flex-row sm:justify-between sm:text-left">
        <p className="text-xs text-gray-400">
          © {new Date().getFullYear()} {displayName}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to={`/login?returnUrl=${returnUrl}`}
            className="font-medium text-primary hover:underline"
          >
            Sign in to borrow
          </Link>
          <Link to="/opac/contact" className="text-gray-600 hover:text-gray-900">
            Contact library
          </Link>
        </div>
      </div>
    </footer>
  );
}
